"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledErrorOverlay = styled_components_1.default.div `
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: ${tokens.ColorGrey900};
  opacity: 0.9;
  @media (max-width: 768px) {
    background-color: ${tokens.ColorWhite000};
    opacity: 1;
    z-index: 1100;
    top: 0;
  }
`;
const StyledErrorContainer = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const StyledErrorMessage = styled_components_1.default.div `
  position: ${props => (props.hideOverlay ? "relative" : "absolute")};
  max-width: ${props => (props.hideOverlay ? "650px" : "590px")};
  max-width: 590px;
  z-index: ${props => (props.hideOverlay ? "0" : "2")};
  border-radius: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, ${props => (props.hideOverlay ? "0" : "-50%")});
  background-color: ${tokens.ColorWhite000};
  padding: 64px;
  text-align: center;
  @media (max-width: 768px) {
    border-radius: 0;
    padding: 32px;
    max-width: calc(100vw - 32px);
    width: calc(100vw - 32px);
    z-index: 1200;
    // top: ${props => (props.hideOverlay ? "auto" : "30%")};
    // transform: ${props => props.hideOverlay ? "translate(-50%,0%)" : "none"};
  }
`;
const ErrorIcon = styled_components_1.default.img `
  width: 64px;
  height: 64px;
`;
const StyledMessageText = styled_components_1.default.div `
  font-family: Nimbus Sans Regular;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.75px;
  text-align: center;
  color: ${tokens.ColorGrey900};
  margin: 32px 0 40px;
  @media (max-width: 768px) {
    font-family: Nimbus Sans Light;
    font-size: 24px;
    line-height: 32px;
  }
`;
const RefreshContainer = styled_components_1.default.div `
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  text-align: center;
  color: ${tokens.ColorBrandInteractiveBlue};
  cursor: pointer;
  text-decoration: none;
  position: absolute;
  top: auto;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  @media (max-width: 768px) {
    bottom: ${props => (props.hideOverlay ? "auto" : "-40%")};
  }
`;
const RefreshIcon = styled_components_1.default.img `
  width: 24px;
  height: 24px;
  margin-right: 8px;
  vertical-align: middle;
  margin-top: -3px;
`;
const HideLink = styled_components_1.default.div `
  font-size: 12px;
  font-family: Nimbus Sans Regular;
  letter-spacing: 0.8px;
  color: ${tokens.ColorBrandInteractiveBlue};
  cursor: pointer;
  text-decoration: underline;
`;
class GlobalErrorComponent extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            showError: true,
            stopScroll: true //stopScroll is used for testing only
        };
    }
    render() {
        const { message, refreshText, hideOverlay, dismissError, icon } = this.props;
        const { showError, stopScroll } = this.state;
        if (!hideOverlay) {
            document.getElementsByTagName("html")[0].style.overflow = "hidden";
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        }
        if (!stopScroll) {
            document.getElementsByTagName("html")[0].style.overflow = "visible";
            document.getElementsByTagName("body")[0].style.overflow = "visible";
        }
        function reloadPage() {
            window.location.reload();
        }
        const hideComponent = () => {
            this.setState({ showError: false, stopScroll: false });
        };
        return (showError && (react_1.default.createElement(react_1.default.Fragment, null,
            !hideOverlay && react_1.default.createElement(StyledErrorOverlay, { tabIndex: 0 }),
            react_1.default.createElement(StyledErrorMessage, { hideOverlay: hideOverlay },
                react_1.default.createElement(ErrorIcon, { src: `data:image/svg+xml;base64,${icon ? icon : tokens.AssetIconCaution}` }),
                react_1.default.createElement(StyledMessageText, null,
                    message,
                    dismissError && (react_1.default.createElement(HideLink, { onClick: hideComponent }, "HIDE MODAL FOR TESTING"))),
                react_1.default.createElement(RefreshContainer, { onClick: reloadPage, hideOverlay: hideOverlay },
                    react_1.default.createElement(RefreshIcon, { src: `data:image/svg+xml;base64,${tokens.AssetIconRefresh}` }),
                    " ",
                    refreshText ? refreshText : "Refresh")))));
    }
}
exports.default = GlobalErrorComponent;
//# sourceMappingURL=GlobalErrorComponent.js.map